<template lang="html">
<div class="c2h4-div__loading">
  <div class="c2h4-div__loading__wrapper" ref="loadingWrapper">
    <canvas id="loading"></canvas>
  </div>
  <common-footer ref="footer"></common-footer>
</div>
</template>
<script>
/* eslint-disable */
import footer from '@/components/common/footer/'
import config from '../../lib/config'
import $ from 'jquery'

export default {
  beforeRouteEnter: (to, from, next) => {
    next(vm => {
      if (from.name === 'result' || from.path === '/') {
        vm.$store.dispatch({
          type: 'storePhoto',
          photo: ''
        })
        vm.$router.push('/')
        window.location.reload()
      }
    })
  },
  components: {
    'common-footer': footer
  },
  mounted () {
    const footer = this.$refs['footer'].$refs['footer']
    this.$refs['loadingWrapper'].style.height = `${window.innerHeight - footer.offsetHeight * 2}px`
    this.loadingCircle()
    let process = 0
    const timer = setInterval(() => {
      process += 2
      this.loadingAnimate(timer, process, 1)
    }, 40)
    this.timer = timer
  },
  methods: {
    loadingCircle () {
      if (this.tips === '未检测到人脸') {
        setTimeout(function() {
          this.$router.push('/upload')
        },1000)
      }
      let tips = !!this.tips ? this.tips : '正在检测肤质...'
      
      const loading = document.getElementById('loading')
      const lCanvas = loading.getContext('2d')
      this.loadingConf = Object.assign(this.loadingConf, {
        radius: loading.offsetHeight / 2 * 2,
        loading: loading,
        lCanvas: lCanvas
      })
      loading.height = loading.offsetHeight * 2
      loading.width = loading.offsetWidth * 2
      const {lineWidth, radius} = this.loadingConf
      lCanvas.beginPath()
      lCanvas.moveTo(radius, 0)
      lCanvas.lineWidth = lineWidth
      lCanvas.strokeStyle = '#ebf0f3'
      lCanvas.arc(radius, radius, radius - lineWidth / 2, -90 * Math.PI / 180, 270 * Math.PI / 180)
      lCanvas.closePath()
      lCanvas.stroke()

      lCanvas.font = '8vw PingFangSC'
      lCanvas.textAlign = 'center'
      lCanvas.textBaseLine = 'middle'
      lCanvas.fillStyle = '#64c8c8'
      lCanvas.fillText(tips, radius, radius)
    },
    loadingAnimate (timer, endAngle, stage, tips) {
      if (endAngle > 1 && timer && stage === 1) {
        clearInterval(timer)
        this.getData(endAngle)
      }
      if (endAngle > 270 && timer && stage === 2) {
        clearInterval(timer)
        if (this.$store.state.result.resultData.total_score) {
          this.$router.push('/result')
        } else {
          this.$router.push('/upload')
        }
      }
      const {lineWidth, radius, lCanvas} = this.loadingConf
      lCanvas.clearRect(0, 0, radius * 2, radius * 2)
      this.loadingCircle(tips)

      lCanvas.beginPath()
      lCanvas.moveTo(radius, lineWidth / 2)
      lCanvas.lineWidth = lineWidth
      lCanvas.strokeStyle = '#64c8c8'
      lCanvas.lineCap = 'round'
      lCanvas.arc(radius, radius, radius - lineWidth / 2, -90 * (Math.PI / 180), endAngle * (Math.PI / 180), false)
      lCanvas.stroke()
    },
    getData (angle) {
      var timer = setInterval(() => {
        angle++
        if (angle >= 220) {
          clearInterval(timer)
        }
        this.loadingAnimate(timer, angle)
      }, 30)
      this.circletimer = timer
      
      const {photo} = this.$store.state.photo.pic
      if (photo) {
        let userUid
        if (!window.localStorage.getItem('user_uid')) {
          const timetemp = new Date().getTime()
          const letterMap = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K']
          let randomLettter = ''
          for (let i = 0, leng = letterMap.length; i < leng; i++) {
            randomLettter +=  letterMap[parseInt(Math.random() * 10)]
          }
          userUid = '' + timetemp + randomLettter
          window.localStorage.setItem('user_uid', userUid)
        } else {
          userUid = window.localStorage.getItem('user_uid')
        }
        let formData = new FormData()
        formData.append('app_id', config.APP_ID)
        formData.append('app_key', config.APP_KEY)
        //formData.append('app_id', 'test')
        //formData.append('app_key', 'test')
        formData.append('own', true)
        formData.append('has_manual', false)
        formData.append('machine_id', 'aaaaaa')
        formData.append('user_uid', userUid)
        formData.append('image', this.$store.state.photo.pic.photo)
        $.ajax({
          url: `${config.hostname}/diagnosis/make/v1`,
          processData: false,
          contentType: false,
          data: formData,
          type: 'POST',
          dataType: 'JSON',
          success: function (res) {
            console.log(res)
            if (res.retcode === 0) {
              this.$store.dispatch({
                type: 'getResult',
                result: res
              })
            } else {
              this.tips = '未检测到人脸'
              this.$router.push('error')
            }
            clearInterval(timer)
            let endtimer = setInterval(() => {
              angle++
              this.loadingAnimate(endtimer, angle, 2, this.tips)
            }, 10)
            this.endtimer = endtimer
          }.bind(this),
          error: function (err) {
            console.log(err)
            console.log('哪里错了')
            this.$router.push('/upload')
          }.bind(this)
        })
      } else {
        window.location = '/c2h42baidu/'
      }
    
    }
  },
  data () {
    return {
      tips: '',
      loadingConf: {
        lineWidth: 12 * 2
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    clearInterval(this.endtimer)
    clearInterval(this.circletimer)
  }
}
</script>

<style scoped>
.c2h4-div__loading{
  width: 100%;
  position: relative;
}
.c2h4-div__loading__wrapper{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
canvas{
  width: 62.666666667vw;
  height: 62.666666667vw;
}
</style>



// WEBPACK FOOTER //
// src/components/Loading/index.vue